"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.moistureLoadResultFragment = exports.moistureLoadToolUserSettings = exports.completeTemplateComponentComponentSectionType = exports.completeSystemTemplateComponentSectionType = exports.completePricingArticle = exports.completeSystemItem = exports.completeSystemFile = exports.completePricingFile = exports.completePricing = exports.completePricingRow = exports.completeLabel = exports.completeOwnerInfo = exports.completeUserSettings = exports.completeUserSettingsSales = exports.completeUserClimateSettings = exports.completeUserCultureSettings = exports.completeCurrency = exports.completeLanguage = exports.completeLocale = exports.completeAmountFieldProfile = exports.completeAmountFieldFormat = exports.completeCoilProFluidResults = exports.completeCoilProSteamTargetTemperatureResults = exports.completeCoilProSteamResults = exports.completeCoilProFreonTargetTemperatureResults = exports.completeCoilProFreonResults = exports.completeEnergyCost = exports.completeEnergyParam = exports.energyResultSystem = exports.energyResultComponent = exports.energyResultOperatingCase = exports.energyResultOperatingCaseResult = exports.energyResultChartPresets = exports.energyResultEnergyListItem = exports.energyResultEnergyTotalItem = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.energyResultEnergyTotalItem = (0, graphql_tag_1.default) `
  fragment EnergyResultEnergyTotalItem on EnergyTotalItemType {
    id
    name
    sortNo
  }
`;
exports.energyResultEnergyListItem = (0, graphql_tag_1.default) `
  fragment EnergyResultEnergyListItem on EnergyListItemType {
    id
    name
    sortNo
  }
`;
exports.energyResultChartPresets = (0, graphql_tag_1.default) `
  fragment EnergyResultChartPresets on EnergyChartPresetType {
    id
    name
    y1Label
    y1AxisType
    y1PerfParams
    y1UnitSi
    y1UnitIp
    y2Label
    y2AxisType
    y2PerfParams
    y2UnitSi
    y2UnitIp
  }
`;
exports.energyResultOperatingCaseResult = (0, graphql_tag_1.default) `
  fragment EnergyResultOperatingCaseResult on OperatingCaseResultType {
    id
    settings
    componentId
  }
`;
exports.energyResultOperatingCase = (0, graphql_tag_1.default) `
  fragment EnergyResultOperatingCase on OperatingCaseType {
    id
    caseType
    binData
    results {
      ...EnergyResultOperatingCaseResult
    }
  }
  ${exports.energyResultOperatingCaseResult}
`;
exports.energyResultComponent = (0, graphql_tag_1.default) `
  fragment EnergyResultComponent on ComponentType {
    id
    productId
    properties
  }
`;
exports.energyResultSystem = (0, graphql_tag_1.default) `
  fragment EnergyResultSystem on SystemItemType {
    id
    binSelections
    revisionNo
    status
    systemFile {
      id
      name
      genesysNo
      systemTypeId
    }
    components {
      ...EnergyResultComponent
    }
    operatingCases {
      ...EnergyResultOperatingCase
    }
  }
  ${exports.energyResultComponent}
  ${exports.energyResultOperatingCase}
`;
exports.completeEnergyParam = (0, graphql_tag_1.default) `
  fragment CompleteEnergyParam on EnergyParamType {
    paramName
    amountFieldValue {
      amount
      amountField {
        fieldGroup
        fieldName
      }
    }
  }
`;
exports.completeEnergyCost = (0, graphql_tag_1.default) `
  fragment CompleteEnergyCost on EnergyCostGraphType {
    name
    cost
    currencySymbol
  }
`;
exports.completeCoilProFreonResults = (0, graphql_tag_1.default) `
  fragment CompleteCoilProFreonResults on FreonResultsType {
    hasError
    errors
    warnings
    airPressureDrop
    airPressureDropDry
    airTotalCapacity
    temperatureOut
    humidityOut
    pressureOut
    flow
    airVelocity
    airStandardVelocity
    condensedWater
    sensibleTotalCapacityRatio
    marginal
    condensingPressure
    evaporationPressure
    totalFreonPressureDrop
    freonGasPressureDrop
    freonLiquidPressureDrop
    freonMixedPressureDrop
    freonMassFlow
    freonInletConnectionVelocity
    freonOutletConnectionVelocity
    freonLiquidVelocity
    freonGasVelocity
  }
`;
exports.completeCoilProFreonTargetTemperatureResults = (0, graphql_tag_1.default) `
  fragment CompleteCoilProFreonTargetTemperatureResults on FreonTargetTemperatureResultsType {
    targetReached
    marginOnTotalPower
    results {
      ...CompleteCoilProFreonResults
    }
  }
  ${exports.completeCoilProFreonResults}
`;
exports.completeCoilProSteamResults = (0, graphql_tag_1.default) `
  fragment CompleteCoilProSteamResults on SteamResultsType {
    hasError
    errors
    warnings
    airPressureDropDry
    airTotalHeat
    steamTotalHeat
    totalHeat
    temperatureOut
    humidityOut
    pressureOut
    flow
    airVelocity
    airStandardVelocity
    sensibleTotalCapacityRatio
    marginal
    gaugeSteamPressure
    steamMassFlow
    steamVelocity
  }
`;
exports.completeCoilProSteamTargetTemperatureResults = (0, graphql_tag_1.default) `
  fragment CompleteCoilProSteamTargetTemperatureResults on SteamTargetTemperatureResultsType {
    targetReached
    marginOnTotalPower
    results {
      ...CompleteCoilProSteamResults
    }
  }
  ${exports.completeCoilProSteamResults}
`;
exports.completeCoilProFluidResults = (0, graphql_tag_1.default) `
  fragment CompleteCoilProFluidResults on FluidResultsType {
    hasError
    errors
    warnings
    airPressureDrop
    airPressureDropDry
    airTotalCapacity
    temperatureOut
    humidityOut
    pressureOut
    flow
    airVelocity
    airStandardVelocity
    connectionVelocity
    condensedWater
    sensibleTotalCapacityRatio
    fluidPressureDrop
    fluidTemperatureIn
    fluidTemperatureOut
    fluidVolumeFlow
    fluidDensity
    fluidVelocity
    reynoldsNumberFluid
    wetRatio
  }
`;
exports.completeAmountFieldFormat = (0, graphql_tag_1.default) `
  fragment CompleteAmountFieldFormat on AmountFieldFormatType {
    id
    fieldGroup
    fieldName
    measureSystem
    unit
    decimalCount
  }
`;
exports.completeAmountFieldProfile = (0, graphql_tag_1.default) `
  fragment CompleteAmountFieldProfile on AmountFieldProfileType {
    id
    name
    measureSystem
    isEditable
    amountFieldFormats {
      ...CompleteAmountFieldFormat
    }
  }
  ${exports.completeAmountFieldFormat}
`;
exports.completeLocale = (0, graphql_tag_1.default) `
  fragment CompleteLocale on LocaleType {
    id
    name
  }
`;
exports.completeLanguage = (0, graphql_tag_1.default) `
  fragment CompleteLanguage on LanguageType {
    id
    texts
  }
`;
exports.completeCurrency = (0, graphql_tag_1.default) `
  fragment CompleteCurrency on CurrencyType {
    id
  }
`;
exports.completeUserCultureSettings = (0, graphql_tag_1.default) `
  fragment CompleteUserCultureSettings on UserSettingsCultureType {
    id
    locale {
      ...CompleteLocale
    }
    language {
      ...CompleteLanguage
    }
    currency {
      ...CompleteCurrency
    }
  }

  ${exports.completeLocale}
  ${exports.completeLanguage}
  ${exports.completeCurrency}
`;
exports.completeUserClimateSettings = (0, graphql_tag_1.default) `
  fragment CompleteUserClimateSettings on UserSettingsClimateType {
    id
    country {
      id
    }
    region {
      id
    }
    location {
      id
    }
    heatingDataType
    coolingDataType
    heatingOccurence
    coolingOccurence
    climateDataSource
    manualData
  }
`;
exports.completeUserSettingsSales = (0, graphql_tag_1.default) `
  fragment CompleteUserSettingsSales on UserSettingsSalesType {
    id
    defaultSalesOrganisation
  }
`;
// We don't want to include a full system in this graph
exports.completeUserSettings = (0, graphql_tag_1.default) `
  fragment CompleteUserSettings on UserSettingsType {
    id
    amountFieldProfiles {
      ...CompleteAmountFieldProfile
    }
    culture {
      ...CompleteUserCultureSettings
    }
    sales {
      ...CompleteUserSettingsSales
    }
    selectedAmountFieldProfile {
      ...CompleteAmountFieldProfile
    }
  }

  ${exports.completeAmountFieldProfile}
  ${exports.completeUserCultureSettings}
  ${exports.completeUserSettingsSales}
`;
exports.completeOwnerInfo = (0, graphql_tag_1.default) `
  fragment CompleteOwnerInfo on UserInfoType {
    id
    name
    userName
  }
`;
exports.completeLabel = (0, graphql_tag_1.default) `
  fragment CompleteLabel on LabelType {
    id
    name
    userProfileId
  }
`;
exports.completePricingRow = (0, graphql_tag_1.default) `
  fragment CompletePricingRow on PricingRowType {
    id
    articleNo
    description
    transferPricePerUnit
    masterPricePerUnit
    systemId
    rowNo
    type
    visualizerCode
    quantity
    unit
    costPerUnit
    pid
  }
`;
exports.completePricing = (0, graphql_tag_1.default) `
  fragment CompletePricing on PricingType {
    id
    name
    comment
    status
    statusDate
    revisionNo
    masterMode
    currencyCode
    salesOrganisationId
    masterSalesOrganisationId
    exchangeRateTemplateId
    owner {
      ...CompleteOwnerInfo
    }
    pricingRows {
      ...CompletePricingRow
    }
    pricingFile {
      ...PricingFile
    }
  }

  ${exports.completeOwnerInfo}
  ${exports.completePricingRow}

  fragment PricingFile on PricingFileType {
    id
    name
    pricingNo
    labels {
      ...CompleteLabel
    }
  }

  ${exports.completeLabel}
`;
exports.completePricingFile = (0, graphql_tag_1.default) `
  fragment CompletePricingFile on PricingFileType {
    id
    name
    pricingNo
    owner {
      ...CompleteOwnerInfo
    }
    latestPricing {
      ...CompletePricing
    }
    pricings {
      ...CompletePricing
    }

    labels {
      ...CompleteLabel
    }
  }

  ${exports.completeOwnerInfo}
  ${exports.completePricing}
  ${exports.completeLabel}
`;
exports.completeSystemFile = (0, graphql_tag_1.default) `
  fragment CompleteSystemFile on SystemFileType {
    id
    name
    genesysNo
    systemTypeId
    isDeleted
    owner {
      ...CompleteOwnerInfo
    }
    labels {
      ...CompleteLabel
    }
    systems {
      id
      revisionNo
      status
      statusDate
      comment
      owner {
        ...CompleteOwnerInfo
      }
    }
  }

  ${exports.completeOwnerInfo}
  ${exports.completeLabel}
`;
exports.completeSystemItem = (0, graphql_tag_1.default) `
  fragment CompleteSystemItem on SystemItemType {
    id
    revisionNo
    status
    statusDate
    comment
    owner {
      ...CompleteOwnerInfo
    }
    systemFile {
      ...CompleteSystemFile
    }
  }
  ${exports.completeOwnerInfo}
  ${exports.completeSystemFile}
`;
exports.completePricingArticle = (0, graphql_tag_1.default) `
  fragment CompletePricingArticle on PricingArticleType {
    id
    salesOrganisationId
    articleNo
    description
    quantity
    unit
    costPerUnit
    transferPricePerUnit
    sortNo
    currencyCode
    templateGroup
  }
`;
exports.completeSystemTemplateComponentSectionType = (0, graphql_tag_1.default) `
  fragment CompleteSystemTemplateComponentSectionType on SystemTemplateComponentSectionType {
    id
    airstream
    productSectionId
    sortNo
  }
`;
exports.completeTemplateComponentComponentSectionType = (0, graphql_tag_1.default) `
  fragment CompleteTemplateComponentComponentSectionType on TemplateComponentComponentSectionType {
    id
    sections {
      ...CompleteSystemTemplateComponentSectionType
    }
  }
  ${exports.completeSystemTemplateComponentSectionType}
`;
exports.moistureLoadToolUserSettings = (0, graphql_tag_1.default) `
  fragment MoistureLoadToolUserSettings on MoistureLoadCalculationSettingsType {
    id
    moistureLoadSettings
    binSettings
    manualClimateBins {
    id
    settings
    }
    climateSettings
    systemOperationTime
    caseSettingsOverrides {
      id
      caseGroup
      settings
    }
    loadCalculationSettings {
      id
      loadType
      operationTime
      loadSettingsOverrides {
        id
        caseGroup
        settings
      }
    }
  }
`;
// export const moistureLoadResultFragment = gql`
//   fragment MoistureLoadResultFragment on MoistureLoadResultType {
//     allResults {
//       freeTextId
//       result {
//         id
//         opcResultType
//         warnings
//         results
//         loadSpecificResults {
//           loadType
//           name
//           results
//         }
//       }
//       partOfDesignCases
//     }
//     binResults {
//       binNumber
//       midPointTemperature
//       result {
//         id
//         opcResultType
//         warnings
//         results
//         loadSpecificResults {
//           loadType
//           name
//           results
//         }
//       }
//     }
//     monthlyResultsNew {
//       textId
//       result {
//         id
//         opcResultType
//         warnings
//         results
//         loadSpecificResults {
//           loadType
//           name
//           results
//         }
//       }
//     }
//     summaryResultsNew {
//       textId
//       result {
//         id
//         opcResultType
//         warnings
//         results
//         loadSpecificResults {
//           loadType
//           name
//           results
//         }
//       }
//     }
//     allBinResults
//     diagramResults
//     diagramResultsToShow
//     summaryAndMonthlyResultsToShow
//     resultWarnings {
//       diagramWarnings {
//         warning
//         plainTextResultNames
//       }
//       summaryWarnings {
//         warning
//         localizedResultNames {
//           name
//           nameResourceString
//         }
//       }
//     }
//     monthlyResults {
//       resultName {
//         name
//         nameResourceString
//       }
//       propertyValueSet
//     }
//     summaryResults {
//       resultName {
//         name
//         nameResourceString
//       }
//       propertyValueSet
//     }
//     maxLoadResults {
//       id
//       selectedFlowId
//       caseType
//       needResourceString
//       caseName
//       operatingCaseResults
//       warnings
//       flowSuggestions {
//         id
//         flowSourceId
//         isValid
//         result
//       }
//     }
//   }
// `;
exports.moistureLoadResultFragment = (0, graphql_tag_1.default) `
  fragment MoistureLoadResultFragment on MoistureLoadResultType {
    allResults {
      operatingCaseNumber
      months
      activeLoads {
          loadType
          name
          }    
      result {
        id
        opcResultType
        warnings
        results
        loadSpecificResults {
          loadIdentification {
            loadType
            name
          }          
          results
        }
      }
      partOfDesignCases
    }
    binResults {
      binNumber
      midPointTemperature
      result {
        id
        opcResultType
        warnings
        results
        loadSpecificResults {
          loadIdentification {
            loadType
            name
          }   
          results
        }
      }
    }
    monthlyResults {
      textId
      result {
        id
        opcResultType
        warnings
        results
        loadSpecificResults {
          loadIdentification {
            loadType
            name
          }   
          results
        }
      }
    }
    summaryResults {
      textId
      result {
        id
        opcResultType
        warnings
        results
        loadSpecificResults {
          loadIdentification {
            loadType
            name
          }   
          results
        }
      }
    }

    resultWarnings {
      diagramWarnings {
        warning
        plainTextResultNames
      }
      summaryWarnings {
        warning
        localizedResultNames {
          name
          nameResourceString
        }
      }
    }

    maxLoadResults {
      id
      selectedFlowId
      caseType
      needResourceString
      caseName
      operatingCaseResults
      warnings
      flowSuggestions {
        id
        flowSourceId
        isValid
        result
      }
    }

    # ------------------ ADD UNION FIELDS HERE ------------------
    allResultsColumnGroups {
      __typename
      ... on MlcStandardWithSumColumnGroup {
        sortNo
        defaultOpened
        textId
        sumPropertyName
        columns {
          sortNo
          propertyName
        }
      }
        ... on MlcStandardColumnGroup {
        sortNo
        defaultOpened
        textId
        columns {
          sortNo
          propertyName
        }
      }
      ... on MlcLoadColumnGroup {
        sortNo
        loadType
        sumPropertyName
        propertyName
      }
    }

    binResultsColumnGroups {
      __typename
      ... on MlcStandardWithSumColumnGroup {
        sortNo
        defaultOpened
        textId
        sumPropertyName
        columns {
          sortNo
          propertyName
        }
      }
        ... on MlcStandardColumnGroup {
        sortNo
        defaultOpened
        textId
        columns {
          sortNo
          propertyName
        }
      }
      ... on MlcLoadColumnGroup {
        sortNo
        loadType
        sumPropertyName
        propertyName
      }
    }

    summaryAndMonthlyResultsColumnGroups {
      __typename
      ... on MlcStandardWithSumColumnGroup {
        sortNo
        defaultOpened
        textId
        sumPropertyName
        columns {
          sortNo
          propertyName
        }
      }
        ... on MlcStandardColumnGroup {
        sortNo
        defaultOpened
        textId
        columns {
          sortNo
          propertyName
        }
      }
      ... on MlcLoadColumnGroup {
        sortNo
        loadType
        sumPropertyName
        propertyName
      }
    }
  }
`;
//# sourceMappingURL=complete-fragments.js.map